<script>
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

export default {
  components: {
    LoadingState,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hasOpenedAtleastOnce: false,
      iframeLoading: true,
    };
  },
  computed: {
    dashboardAppContext() {
      return {
        conversation: this.currentChat,
        contact: this.$store.getters['contacts/getContact'](this.contactId),
        currentAgent: this.currentAgent,
      };
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
    /**
     * Centertel: Injeta cwc_* params na URL do iframe para que o embed
     * receba telefone, agente, labels, etc. via query params.
     */
    enrichedConfig() {
      if (!this.currentChat?.id) return this.config;
      const contact = this.currentChat?.meta?.sender || {};
      const agent = this.currentAgent || {};
      const team = this.currentChat?.meta?.team || {};
      const labels = (this.currentChat?.labels || []).join(',');

      const cwcParams = new URLSearchParams({
        cwc_phone: contact.phone_number || '',
        cwc_contact_name: contact.name || '',
        cwc_contact_id: String(contact.id || ''),
        cwc_agent_name: agent.name || '',
        cwc_agent_id: String(agent.id || ''),
        cwc_conv_id: String(this.currentChat.id || ''),
        cwc_conv_status: this.currentChat.status || '',
        cwc_team: team.name || '',
        cwc_labels: labels,
      });

      return this.config.map(item => {
        if (item.type !== 'frame' || !item.url) return item;
        // Remover params cwc_ antigos
        const urlObj = new URL(item.url, window.location.origin);
        for (const key of [...urlObj.searchParams.keys()]) {
          if (key.startsWith('cwc_')) urlObj.searchParams.delete(key);
        }
        // Adicionar novos
        cwcParams.forEach((val, key) => {
          if (val) urlObj.searchParams.set(key, val);
        });
        return { ...item, url: urlObj.toString() };
      });
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.hasOpenedAtleastOnce = true;
      }
    },
    /**
     * Centertel: quando a conversa muda, recarregar o iframe
     * com os novos params (sem esperar postMessage).
     */
    'currentChat.id'() {
      if (this.hasOpenedAtleastOnce) {
        this.iframeLoading = true;
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.triggerEvent);
  },
  unmounted() {
    window.removeEventListener('message', this.triggerEvent);
  },
  methods: {
    triggerEvent(event) {
      if (!this.isVisible) return;
      if (
        event.data === 'chatwoot-dashboard-app:fetch-info' ||
        event.data === 'appContext'
      ) {
        this.onIframeLoad(0);
      }
    },
    getFrameId(index) {
      return `dashboard-app--frame-${this.position}-${index}`;
    },
    onIframeLoad(index) {
      const frameElement = document.getElementById(this.getFrameId(index));
      if (!frameElement) return;
      const eventData = { event: 'appContext', data: this.dashboardAppContext };
      frameElement.contentWindow.postMessage(JSON.stringify(eventData), '*');
      this.iframeLoading = false;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="hasOpenedAtleastOnce" class="dashboard-app--container">
    <div
      v-for="(configItem, index) in enrichedConfig"
      :key="currentChat.id + '-' + index"
      class="dashboard-app--list"
    >
      <LoadingState
        v-if="iframeLoading"
        :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
        class="dashboard-app_loading-container"
      />
      <iframe
        v-if="configItem.type === 'frame' && configItem.url"
        :id="getFrameId(index)"
        :src="configItem.url"
        @load="() => onIframeLoad(index)"
      />
    </div>
  </div>
</template>

<style scoped>
.dashboard-app--container,
.dashboard-app--list,
.dashboard-app--list iframe {
  height: 100%;
  width: 100%;
}

.dashboard-app--list iframe {
  border: 0;
}
.dashboard-app_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
